import { render } from "./HistoryExport.vue?vue&type=template&id=91985a4e"
import script from "./HistoryExport.vue?vue&type=script&lang=js"
export * from "./HistoryExport.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__